import { useContext, useEffect, useState } from 'react';
import Inputs from './components/inputs';
import useHttp from '../../../hooks/use-http';
import { urls } from './api/urls';
import toast from 'react-hot-toast';
import { handleErrorMessage } from '../../../../shared/api/handleErrorMessage';
import { TabContext } from '../../../Context/TabContext';
import TabsProvider from './components/TabsProvider';
import { isFormValid } from './validation/isFormValid';
import { useTranslation } from 'react-i18next';
import MuiDialog from '../../UI/MuiDialog/MuiDialog';
import DetaljiRN from './DetaljiRN';
import MultiSelectDialog from '../../UI/MultiSelectDialog/MultiSelectDialog';
import Dnevnik from './Dnevnik/Dnevnik';
import Beleske from './Beleske/Beleske';
import Fajlovi from './Fajlovi/Fajlovi';
import IzvestajRadnogNalogaDialog, {
  TIP_IZVESTAJA,
} from '../shared/IzvestajRadnogNaloga/IzvestajRadnogNalogaDialog';

const INITIAL_VALUES = {
  idDok: 0,
  ceoBrDok: '',
  datum: null,
  idKorProm: +localStorage.getItem('idKorisnika'),
  napomena: '',
  idDokServisnogZahteva: null,
  datumZavrsetka: null,
  opisRadova: '',
  idKupca: 0,
  nazivKupca: '',
  opisProblema: '',
  idMasine: null,
  idPodProjekta: null,
  nazivPodProjekta: '',
  nazivMasine: '',
  zavrsen: false,
  naplacujeSe: false,
  teren: false,
};
const INITIAL_ZAHTEV_VALUES = {
  id: 0,
  idDok: 0,
  ceoBrDok: '',
  idStatusa: 0,
  status: '',
  metadataStatusa: '',
  idMasine: 0,
  nazivMasine: '',
  naslov: '',
  opisProblema: '',
  datumZatvaranja: null,
  idPrioriteta: null,
  kodGreske: '',
  brojSatiRada: 0,
  opisProblemaDetaljan: null,
  idKorProm: 0,
  vremeProm: null,
  idKorKreiranja: 2,
  vremeKreiranja: null,
  idStatusaMasine: 0,
  statusMasine: '',
  vrsteKvarova: null,
  napomena: null,
  poslato: false,
  datumSlanja: null,
  IdKupcaKorisnikaPrograma: 0,
  NazivFirmeKorisnikaPrograma: '',
  listaVrstaKvarova: [],
};

const PregledRadnogNaloga = ({
  save,
  handleSave,
  detail,
  handleDetail,
  handleDisableDetail,
  dodeliZaposlenima,
  handleDodeliZaposlenima,
  dnevnik,
  handleDnevnik,
  handleDisableDodeliZaposlenima,
  kreirajDokument,
  handleKreirajDokument,
  pdfIzvestaj,
  handlePdfIzvestaj,
}) => {
  const { t, i18n } = useTranslation();
  const [openPdfIzvestaj, setOpenPdfIzvestaj] = useState(false);
  const { tabsData, activeComponent } = useContext(TabContext);
  const dataLocal = tabsData.find((item) => item.type === activeComponent);
  const radniNalogLocal = dataLocal?.data ? dataLocal?.data : INITIAL_VALUES;
  const [openFajlovi, setOpenFajlovi] = useState(false);
  const { getData } = useHttp('');
  const { sendRequest: getZaposleni, data: zaposleniData } = useHttp('');
  const [formValues, setFormValues] = useState(INITIAL_VALUES);
  const [servisniZahtevValues, setServisniZahtevValues] = useState(
    INITIAL_ZAHTEV_VALUES,
  );
  const [dataPonude, setDataPonude] = useState({});
  const [openPregledRN, setOpenPregledRN] = useState(false);
  const [showSuma, setShowSuma] = useState({
    zaposleni: false,
    transport: false,
    delovi: false,
    troskovi: false,
    zaglavlje: false,
  });
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [openDnevnik, setOpenDnevnik] = useState(false);

  // vracanje zaposlenih
  useEffect(() => {
    getZaposleni({ url: urls.GET_ZAPOSLENI_COMBO });
  }, []);
  // otvaranje dijaloga za dodeljivanje radnog naloga
  useEffect(() => {
    if (dodeliZaposlenima) {
      setOpenDialog(dodeliZaposlenima);
    }
    handleDodeliZaposlenima(false);
  }, [dodeliZaposlenima]);

  useEffect(() => {
    if (dnevnik) {
      setOpenDnevnik(true);
    }
    handleDnevnik(false);
  }, [dnevnik]);

  useEffect(() => {
    if (localStorage.sa !== 'true' || !radniNalogLocal?.idDok) {
      handleDisableDetail(true);
    } else {
      handleDisableDetail(false);
    }
  }, []);
  useEffect(() => {
    if (!radniNalogLocal?.idDok) {
      console.log('first');
      handleDisableDodeliZaposlenima(true);
    } else {
      console.log('first2');
      handleDisableDodeliZaposlenima(false);
    }
  }, []);

  const vratiServisniZahtev = async (id) => {
    const config = {
      method: 'POST',
      url: urls.GET_SERVISNI_ZAHTEV_ZA_ID,
      data: { id: id, metadata: i18n.language },
    };
    const response = await getData(config);
    console.log('servisni zahtev', response);
    if (response.id > 0) {
      setFormValues({
        ...INITIAL_VALUES,
        nazivKupca: response.NazivFirmeKorisnikaPrograma,
        idKupca: response.IdKupcaKorisnikaPrograma,
        idMasine: response.idMasine,
        // ide u stringu jer iz api-ja vraca naziv sa space na kraju npr nazivMasine='r967 '
        nazivMasine: `${response.oznakaKupca} `,
        idDokServisnogZahteva: response.idDok,
      });
      setServisniZahtevValues(response);
    }
  };
  const vratiServisniZahtevIzmenaNaloga = async (id) => {
    const config = {
      method: 'POST',
      url: urls.GET_SERVISNI_ZAHTEV_ZA_ID,
      data: { id: id, metadata: i18n.language },
    };
    const response = await getData(config);
    if (response.id > 0) {
      setServisniZahtevValues(response);
    }
  };
  // vraca zaposlene kojima je dodeljen radni nalog
  const vratiZaposleneZaRadniNalog = async (id) => {
    const config = {
      method: 'POST',
      url: urls.GET_ZAPOSLENI_ZA_RN,
      data: { id: id },
    };
    const result = await getData(config);
    setSelectedItems(result);
    console.log('lista zaposlenih za radni nalog', result);
  };
  useEffect(() => {
    // console.log('local data', radniNalogLocal);
    // console.log('RADNI NALOG LOCAL', radniNalogLocal);
    if (radniNalogLocal.prenetiIdServisnogZahteva > 0) {
      // console.log('IZ SERVISNOG ZAHTEVA');
      vratiServisniZahtev(radniNalogLocal.prenetiIdServisnogZahteva);
    } else {
      // console.log(// console.log('IZ RADNOG NALOGA'));
      vratiServisniZahtevIzmenaNaloga(radniNalogLocal.idDokServisnogZahteva);
      console.log(radniNalogLocal);
      vratiZaposleneZaRadniNalog(radniNalogLocal.idDok);
      setFormValues(radniNalogLocal);
    }
  }, [i18n.language]);

  const handleSaveData = async () => {
    if (isFormValid(formValues)) {
      return;
    }
    const config = {
      method: 'POST',
      url:
        formValues.idDok !== 0
          ? urls.UPDATE_RADNI_NALOG
          : urls.INSERT_RADNI_NALOG,
      data: {
        ...formValues,
        OpisProblemaRN: formValues.opisProblema,
        id: formValues.idDok,
        idKorProm: +localStorage.getItem('idKorisnika'),
      },
    };
    const response = await getData(config);
    if (response.idDok > 0) {
      setFormValues(response);
      handleDisableDodeliZaposlenima(false);
      toast.success(
        formValues.idDok === 0
          ? 'Uspešan unos podatak'
          : 'Uspešna izmena podataka',
      );
      return;
    }
    toast.error(handleErrorMessage(response));
  };
  const vratiDetaljeRN = async () => {
    const config = {
      method: 'POST',
      url: urls.VRATI_PREGLED_SERVISA,
      data: {
        id: radniNalogLocal.idDok,
        metadata: i18n.language,
      },
    };
    const response = await getData(config);
    setDataPonude(response);
    setOpenPregledRN(true);
  };
  const handleIsExpanded = (e, expanded, name) => {
    console.log(name);
    setShowSuma((curr) => {
      return { ...curr, [name]: expanded };
    });
  };
  useEffect(() => {
    if (save) {
      handleSaveData();
      handleSave(false);
    }
  }, [save]);

  useEffect(() => {
    if (detail) {
      vratiDetaljeRN();
      handleDetail(false);
    }
  }, [detail]);
  const handleClose = () => {
    setOpenDialog(false);
  };
  // funkcija za upisivanje liste zaposlenih za radni nalog
  const handleDodeliZaposlenimaRadniNalog = async () => {
    console.log('lista', selectedItems);
    // dodat komisija false jer api trazi tako.
    const itemsArr = selectedItems.map((item) => {
      return { ...item, komisija: false };
    });
    const config = {
      method: 'POST',
      url: urls.DODELI_ZAPOSLENIMA,
      data: {
        id: formValues.idDok,
        idKorProm: +localStorage.getItem('idKorisnika'),
        listaZaposlenih: itemsArr,
      },
    };
    const result = await getData(config);
    toast.success('Uspešno dodeljen radni nalog.');
    console.log(result);
  };

  useEffect(() => {
    if (kreirajDokument) {
      if (
        formValues.idDok !== 0 &&
        formValues.idDok !== null &&
        formValues.idDok !== undefined
      ) {
        setOpenFajlovi(true);
        handleKreirajDokument(false);
      }
      handleKreirajDokument(false);
    }
  }, [kreirajDokument]);

  useEffect(() => {
    if (pdfIzvestaj) {
      if (formValues.idDok) setOpenPdfIzvestaj(true);
      handlePdfIzvestaj(false);
    }
  }, [pdfIzvestaj]);
  return (
    <div>
      <IzvestajRadnogNalogaDialog
        open={openPdfIzvestaj}
        idDok={formValues.idDok}
        tip={TIP_IZVESTAJA.RN}
        onClose={() => setOpenPdfIzvestaj(false)}
      />
      <Inputs
        formValues={formValues}
        setFormValues={setFormValues}
        servisniZahtevValues={servisniZahtevValues}
      />

      <MuiDialog
        maxWidth="xl"
        open={openFajlovi}
        title={t('files')}
        content={
          <div>
            <Fajlovi id={formValues.idDok} />
          </div>
        }
        handleClose={() => setOpenFajlovi(false)}
        deniedText="ZATVORI"
      />

      <TabsProvider
        idRn={formValues.idDok}
        naplacujeSe={formValues.naplacujeSe}
      />
      <MuiDialog
        maxWidth="xl"
        open={openPregledRN}
        title="Troškovi"
        content={
          <DetaljiRN
            dataPonude={dataPonude}
            showSuma={showSuma}
            handleIsExpanded={handleIsExpanded}
            naplacujeSe={formValues.naplacujeSe}
          />
        }
        handleClose={() => {
          setOpenPregledRN(false);
          setShowSuma({
            zaposleni: false,
            transport: false,
            delovi: false,
            troskovi: false,
            zaglavlje: false,
          });
        }}
        deniedText="ZATVORI"
      />
      <MuiDialog
        maxWidth="xl"
        open={openDnevnik}
        title={t('dnevnik')}
        content={<Dnevnik rnValues={formValues} />}
        handleClose={() => setOpenDnevnik(false)}
        deniedText="ZATVORI"
      />

      <MultiSelectDialog
        data={zaposleniData}
        openDialog={openDialog}
        handleClose={handleClose}
        setSelectedItems={setSelectedItems}
        selectedItems={selectedItems}
        handleConfirm={handleDodeliZaposlenimaRadniNalog}
      />
    </div>
  );
};

export default PregledRadnogNaloga;
